import { track } from '@amplitude/analytics-browser';
import { AnalyticsBrowser } from '@segment/analytics-next'

export const analytics = AnalyticsBrowser.load({ writeKey: 'pfngt2Kw6E5po4ika1M2lFPGTEhZBPDw' })

export const eventTracker = (event: string, properties: any) => {
    if((window as any).clientIdentifier) {
        track(event, {properties, platform: 'web', client: (window as any).clientIdentifier});
    } else {
        track(event, {properties, platform: 'web'});
    }

}
